import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../utils/utils";
import InfoPersoRecapBloc from "../blocs/info-perso/InfoPersoRecapBloc";
import useAppState from "../context/AppContext";
import { isConfirmedContactProposition } from "../utils/dataUtils";

export default function InfoPersoRecapPage() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

  const {
    state: { proposition }
  } = useAppState();

    return (
    
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">{ isConfirmedContactProposition(proposition!) ? 'Vos informations personnelles' : 'Confirmez vos informations personnelles' } </h1>
        <div ref={pageGapRef} className="page-gap" />
        <div className="flex-grid m-lg-desktop">
            <InfoPersoRecapBloc />
        </div>
      </div>
   
    )

}